/**
 * AUTOUR D'OÙ CHERCHER UN FORMATEUR POUR UNE DEMANDE : là où la formation aura
 * lieu, et à défaut là où est le client.
 *
 * — INTRA ou location de salle : le lieu de formation saisi ;
 * — INTER : la ville de la session ;
 * — sinon, ou si le lieu est vide : le code postal du client.
 *
 * LE CODE POSTAL D'ABORD. Seul, il se résout côté serveur sans géocodage, au
 * centre de la commune — le même repère que celui des formateurs, donc des
 * distances comparables. L'adresse complète ne part qu'à défaut de code postal.
 *
 * @param {Object|null} quote - La demande telle qu'affichée (snake_case).
 * @returns {{ recherche: string, libelle: string }|null}
 */
export function lieuDeReference(quote) {
  if (!quote) return null
  return lieuDeFormation(quote) || villeInter(quote) || adresseDuClient(quote)
}

function lieuDeFormation(quote) {
  if (quote.formation_lieu !== 'INTRA' && quote.formation_lieu !== 'LOCATION') return null
  return depuis(quote.lieu_formation_code_postal, quote.lieu_formation_ville, quote.lieu_formation_adresse)
}

function villeInter(quote) {
  if (quote.formation_lieu !== 'INTER') return null
  const ville = texte(quote.inter_ville)
  return ville ? { recherche: ville, libelle: ville } : null
}

function adresseDuClient(quote) {
  return quote.client_type === 'particulier'
    ? depuis(quote.particulier_code_postal, quote.particulier_ville, quote.particulier_adresse)
    : depuis(quote.professionnel_code_postal, quote.professionnel_ville, quote.professionnel_adresse)
}

function depuis(codePostal, ville, adresse) {
  const cp = texte(codePostal)
  const nomVille = texte(ville)
  const libelle = [cp, nomVille].filter(Boolean).join(' ')
  if (/^\d{5}$/.test(cp)) return { recherche: cp, libelle }
  const complete = [texte(adresse), libelle].filter(Boolean).join(', ')
  return complete ? { recherche: complete, libelle: libelle || complete } : null
}

const texte = (valeur) => String(valeur || '').trim()
